export const zIndex = {
  base: 1,
  raised: 10,
  sticky: 100,
  modal: 500,
  floating: 700,
  header: 800,
  dialog: 900,
  tooltip: 950,
  debug: 9999,
} as const;
